// import React, { useMemo } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Grid,
//   TextField,
//   MenuItem,
//   Alert,
//   Tooltip,
//   IconButton,
//   InputAdornment,
// } from "@mui/material";
// import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
// import EmailPreview from "./EmailPreview";

// const SendEmailDialog = ({
//   open,
//   onClose,
//   templates,
//   sendForm,
//   setSendForm,
//   onSend,
// }) => {
//   const selectedSendTemplate =
//     templates.find((t) => t.id === sendForm.template_id) || null;

//   const previewVariableMap = useMemo(() => {
//     try {
//       return JSON.parse(sendForm.variablesText || "{}");
//     } catch {
//       return {};
//     }
//   }, [sendForm.variablesText]);

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
//       <DialogTitle>Send Email</DialogTitle>

//       <DialogContent dividers>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Select Template"
//                   value={sendForm.template_id}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       template_id: e.target.value,
//                     }))
//                   }
//                 >
//                   {templates
//                     .filter((t) => t.status === "active")
//                     .map((t) => (
//                       <MenuItem key={t.id} value={t.id}>
//                         {t.name} ({t.is_global ? "Global" : "Private"})
//                       </MenuItem>
//                     ))}
//                 </TextField>
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Recipient Email"
//                   value={sendForm.recipient_email}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       recipient_email: e.target.value,
//                     }))
//                   }
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Reply-To"
//                   value={sendForm.reply_to}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       reply_to: e.target.value,
//                     }))
//                   }
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Unsubscribe URL"
//                   value={sendForm.unsubscribe_url}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       unsubscribe_url: e.target.value,
//                     }))
//                   }
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Campaign ID"
//                   value={sendForm.campaign_id}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       campaign_id: e.target.value,
//                     }))
//                   }
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   multiline
//                   minRows={10}
//                   label="Variables JSON"
//                   value={sendForm.variablesText}
//                   onChange={(e) =>
//                     setSendForm((prev) => ({
//                       ...prev,
//                       variablesText: e.target.value,
//                     }))
//                   }
//                   helperText='Example: { "name": "Priya", "discount": "20" }'
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <Tooltip title="Copy variable json skeleton">
//                           <IconButton
//                             onClick={() => {
//                               const vars =
//                                 selectedSendTemplate?.variables?.reduce(
//                                   (acc, key) => ({ ...acc, [key]: "" }),
//                                   {}
//                                 ) || {};
//                               navigator.clipboard.writeText(
//                                 JSON.stringify(vars, null, 2)
//                               );
//                             }}
//                           >
//                             <ContentCopyOutlinedIcon />
//                           </IconButton>
//                         </Tooltip>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             {selectedSendTemplate ? (
//               <EmailPreview
//                 form={selectedSendTemplate}
//                 variableMap={previewVariableMap}
//               />
//             ) : (
//               <Alert severity="info">
//                 Select an active template to preview the email.
//               </Alert>
//             )}
//           </Grid>
//         </Grid>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" startIcon={<SendOutlinedIcon />} onClick={onSend}>
//           Send Now
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default SendEmailDialog;


import React, { useMemo } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid,
  TextField, MenuItem, Alert, Tooltip, IconButton, InputAdornment, Box, Typography, Stack
} from "@mui/material";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import EmailPreview from "./EmailPreview";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", backgroundColor: "#f8f9fb",
    "&:hover": { backgroundColor: "#f0f2f5" },
    "&.Mui-focused": { backgroundColor: "#fff", "& .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 } }
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent }
};

const SendEmailDialog = ({ open, onClose, templates, sendForm, setSendForm, onSend }) => {
  const selectedSendTemplate = templates.find((t) => t.id === sendForm.template_id) || null;
  const previewVariableMap = useMemo(() => { try { return JSON.parse(sendForm.variablesText || "{}"); } catch { return {}; } }, [sendForm.variablesText]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, color: "#fff", fontWeight: 700 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <SendOutlinedIcon /> <span>Send Email</span>
        </Stack>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Stack spacing={2.5}>
              <TextField select fullWidth label="Select Template" value={sendForm.template_id}
                onChange={(e) => setSendForm((p) => ({ ...p, template_id: e.target.value }))} sx={inputSx}>
                {templates.filter((t) => t.status === "active").map((t) => (
                  <MenuItem key={t.id} value={t.id}>{t.name} ({t.is_global ? "Global" : "Private"})</MenuItem>
                ))}
              </TextField>
              <TextField fullWidth label="Recipient Email" value={sendForm.recipient_email}
                onChange={(e) => setSendForm((p) => ({ ...p, recipient_email: e.target.value }))} sx={inputSx} />
              <TextField fullWidth label="Reply-To" value={sendForm.reply_to}
                onChange={(e) => setSendForm((p) => ({ ...p, reply_to: e.target.value }))} sx={inputSx} />
              <TextField fullWidth label="Unsubscribe URL" value={sendForm.unsubscribe_url}
                onChange={(e) => setSendForm((p) => ({ ...p, unsubscribe_url: e.target.value }))} sx={inputSx} />
              <TextField fullWidth label="Campaign ID" value={sendForm.campaign_id}
                onChange={(e) => setSendForm((p) => ({ ...p, campaign_id: e.target.value }))} sx={inputSx} />
              <TextField fullWidth multiline minRows={8} label="Variables JSON" value={sendForm.variablesText}
                onChange={(e) => setSendForm((p) => ({ ...p, variablesText: e.target.value }))}
                helperText='Example: { "name": "Priya", "discount": "20" }' sx={inputSx}
                InputProps={{ endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Copy variable skeleton">
                      <IconButton onClick={() => {
                        const vars = selectedSendTemplate?.variables?.reduce((acc, key) => ({ ...acc, [key]: "" }), {}) || {};
                        navigator.clipboard.writeText(JSON.stringify(vars, null, 2));
                      }}><ContentCopyOutlinedIcon /></IconButton>
                    </Tooltip>
                  </InputAdornment>
                )}} />
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            {selectedSendTemplate ? (
              <EmailPreview form={selectedSendTemplate} variableMap={previewVariableMap} />
            ) : (
              <Alert severity="info" sx={{ borderRadius: 2 }}>Select an active template to preview.</Alert>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ color: "#666" }}>Cancel</Button>
        <Button variant="contained" startIcon={<SendOutlinedIcon />} onClick={onSend}
          sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, borderRadius: 2, px: 3, fontWeight: 600 }}>Send Now</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendEmailDialog;
